module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-two-b_cta@2x.d79b84fd.jpg";